import { render } from "./CollectionTypeComponent.vue?vue&type=template&id=bf948a98&scoped=true"
import script from "./CollectionTypeComponent.vue?vue&type=script&lang=js"
export * from "./CollectionTypeComponent.vue?vue&type=script&lang=js"

import "./CollectionTypeComponent.vue?vue&type=style&index=0&id=bf948a98&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf948a98"]])

export default __exports__